import styled from "@emotion/styled";
import {
  PRIMARY_BLACK,
  TERTIARY_GREY,
  OLD_BLUE,
  PRIMARY_GREY,
  BACKGROUND_LIGHT,
  GHOST_BACKGROUND,
} from "src/constants/colors";

export const PackageContainer = styled.div`
  background: ${PRIMARY_GREY};
  border-radius: 16px;
  padding: 8px;

  & button {
    width: 100%;
    background: ${GHOST_BACKGROUND};
    color: ${OLD_BLUE};
  }
`;

export const PackageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 8px;
  margin-bottom: 12px;
`;

export const PackageTitle = styled.h3`
  font-size: 14px;
  font-weight: 500;
  color: ${PRIMARY_BLACK};
  margin: 0 0 8px 0;
`;

export const PackageSubtitle = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: ${TERTIARY_GREY};
  margin: 0;
`;

export const ZipIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  padding: 8px;
  background: ${BACKGROUND_LIGHT};
  color: ${OLD_BLUE};
`;
